import { useEffect } from 'react'

import { IrisValueObjectsExportFormatEnum } from 'generated/resources/graphql'

import {
  buildExportSecondaryActions,
  isExportSecondaryAction,
} from 'modules/ai_reports/lib/buildExportSecondaryActions'
import { useResourceHeader } from 'modules/layout/components/ResponsivePage/hooks'

type UseExportHeaderActionsParams = {
  exportFormats: IrisValueObjectsExportFormatEnum[]
  loading: boolean
}

export const useExportHeaderActions = ({
  exportFormats,
  loading,
}: UseExportHeaderActionsParams) => {
  const { updateHeader } = useResourceHeader()

  useEffect(() => {
    updateHeader((header) => {
      const secondaryActions = header?.secondaryActions ?? []

      return {
        ...(header ?? {}),
        secondaryActions: [
          ...secondaryActions.filter((action) => !isExportSecondaryAction(action)),
          ...buildExportSecondaryActions(exportFormats, { loading }),
        ],
      }
    })

    return () => {
      updateHeader((header) => {
        if (!header?.secondaryActions?.some(isExportSecondaryAction)) return header

        const remainingSecondaryActions = header.secondaryActions.filter(
          (action) => !isExportSecondaryAction(action)
        )

        return {
          ...header,
          secondaryActions:
            remainingSecondaryActions.length > 0 ? remainingSecondaryActions : undefined,
        }
      })
    }
  }, [exportFormats, loading, updateHeader])
}
